import { configCategory, configTeaser } from "@pub/config";
import placeholders from "@pub/placeholders";
import {
  AnchorBlock,
  Card,
  CustomClassContext,
} from "@sphtech/dmg-design-system";
import cx from "classnames";
import { ReactNode, useContext } from "react";

import styles from "../category.module.css";
import { CategoryLayoutElementProps } from "../types/types";

export default function CategoryAnchorBlock({
  data,
}: CategoryLayoutElementProps): ReactNode {
  const customClass = useContext(CustomClassContext);
  const sectionContainerClass = customClass?.categoryLayout?.sectionContainer;
  const categoryLayout = configCategory.card;

  if (!data.anchorBlock) {
    return null;
  }

  return (
    <section
      className={cx(
        styles.bodyContainer,
        styles.gutterBottomOnly,
        styles.categoryAnchorBlockContainer,
        sectionContainerClass,
        customClass?.categoryLayout?.anchorBlock,
      )}
    >
      {categoryLayout ? (
        <Card
          {...data.anchorBlock}
          variant={categoryLayout.anchorblock.defaultVariant}
          mobileUpVariant={categoryLayout.anchorblock.mobileUp.defaultVariant}
          placeholders={placeholders}
          displayPublishDate={configTeaser.anchorBlock?.publishDate}
        />
      ) : (
        <AnchorBlock
          {...data.anchorBlock}
          placeholder={placeholders.landscape}
          displayPublishDate={configTeaser.anchorBlock?.publishDate}
          mobileCrop={configTeaser.anchorBlock?.mobileCrop}
        />
      )}
    </section>
  );
}
